import axios from 'axios';

const api = axios.create({
  baseURL:  'https://api.teltrip.com/api',
  // baseURL: 'http://localhost:5073/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config:any) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers = config.headers || {};
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response, // Return successful responses as-is
  (error) => {
    // Extract the error message from the API response
    let errorMessage = 'An error occurred';
    
    if (error.response) {
      // The server responded with a status code outside of 2xx range
      if (error.response.data) {
        if (typeof error.response.data === 'string') {
          errorMessage = error.response.data;
        } else if (error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.response.data.error) {
          errorMessage = error.response.data.error;
        } else if (error.response.data.title) {
          errorMessage = error.response.data.title;
        }
      } else {
        errorMessage = `Error: ${error.response.status} ${error.response.statusText}`;
      }
    } else if (error.request) {
      // The request was made but no response was received
      errorMessage = 'No response received from server';
    } else {
      // Something happened in setting up the request
      errorMessage = error.message || 'Unknown error';
    }
    
    // Attach the extracted error message to the error object
    error.displayMessage = errorMessage;
    
    return Promise.reject(error);
  }
);

export default api;
